import * as stylex from "@stylexjs/stylex";

export const controlStyles = stylex.create({
  control: {
    position: "absolute",
    top: 8,
    zIndex: 20,
    display: "flex",
    width: 32,
    height: 32,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "rgba(255, 255, 255, 0.2)",
    backgroundColor: {
      default: "rgba(0, 0, 0, 0.5)",
      ":hover": "rgba(0, 0, 0, 0.7)",
    },
    color: "rgba(255, 255, 255, 0.9)",
    opacity: { default: 0.7, ":hover": 1, ":focus-visible": 1 },
    backdropFilter: "blur(4px)",
    cursor: "pointer",
    transitionProperty: "opacity, background-color",
    transitionDuration: { default: "150ms", ":focus-visible": "0ms" },
    outline: {
      default: "none",
      ":focus-visible": "2px solid rgba(255, 255, 255, 0.7)",
    },
    outlineOffset: 2,
  },
  pause: { left: 8 },
  fullscreen: { right: 8 },
});
